module.exports = __webpack_public_path__ + "img/S__70344728.6ff65839.jpg";